module.exports = __webpack_public_path__ + "static/img/cont32_03.02dad3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont32_03.jpg
// module id = rdxO
// module chunks = 0